import Instance from '../../../Axios';

const EditarCategoria = (ydata, id) => async (dispatch) => {
  await Instance()
    .put(`/backend/categorias/${id}`, { ydata })
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'PUT_CATEGORIA', payload: data });
      //   show('success', 'Foram associados novos funcionários á obra');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default EditarCategoria;
